<div *ngIf="modal" class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{name}}</h4>
  <button type="button" class="fa fa-arrows" aria-label="Maximize" (click)="maximize()">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body">
  <ngb-tabset [justify]="'start'">
    <!-- <ngb-tab id="ping_graphlook" title="{{ 'PING_GRAPH' | translate }}">
      <ng-template ngbTabContent>
        <div style="display: block">
          <canvas *ngIf="nodeData?.length" baseChart [datasets]="nodeData" [labels]="labels" [options]="nodeOption"
            [colors]="nodeChartColor" legend="true" chartType="line" (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)"></canvas>
        </div>
      </ng-template>
    </ngb-tab> -->
    <ngb-tab id="ping_table" title="{{ 'PING_TABLE' | translate }}">
      <ng-template ngbTabContent>
        <app-ping-table [id]="id"></app-ping-table>
      </ng-template>
    </ngb-tab>

    <!-- <ngb-tab *ngIf="node_data && (node_data | typeFilter:'string').length" id="2" title="{{ 'INFO' | translate }}">
      <ng-template ngbTabContent>
        <div *ngFor="let word of node_data | typeFilter:'string'">
          <span class="text-info"> {{word}}:</span>
          {{node_data|keys:word}}
          <br>
        </div>
      </ng-template>
    </ngb-tab> -->

    <ngb-tab *ngFor="let item of node_data | typeFilter:'object'" [id]="item" title="{{item}}">
      <ng-template ngbTabContent>
        <dx-data-grid [id]="item" [dataSource]="node_data|keys:item" [rtlEnabled]="rtl" [columnAutoWidth]="true"
          [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="false">
          </dxo-pager>
          <dxo-column-chooser [enabled]="true" mode="select">
          </dxo-column-chooser>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="node_log_{{item}}_grid">
          </dxo-state-storing>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true" [excelFilterEnabled]="true"
            fileName="{{item}}-{{exportFileName}}">
            <dxo-texts exportAll="{{'SELECT_ALL' | translate}}"
              exportSelectedRows="{{'EXPORT_FROM_SELECTED_ROW' | translate}}">
            </dxo-texts>
          </dxo-export>
          <dxo-search-panel [visible]="true" [width]="250" placeholder="{{'FILTER' | translate}}"
            [highlightSearchText]="true"></dxo-search-panel>
          <dxo-header-filter [visible]="true" [allowSearch]="true" [height]="400" [width]="300">
            <dxo-texts cancel="{{'CANCEL' | translate}}" emptyValue="{{'EMPTY' | translate}}"
              ok="{{'DONE' | translate}}">
            </dxo-texts>
          </dxo-header-filter>
        </dx-data-grid>
      </ng-template>
    </ngb-tab>

  </ngb-tabset>


</div>